import { Component } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { ItemComponent } from './item/item.component';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.css']
})



export class AppComponent {

  title: Observable<any[]>;

  items: Observable<any[]>;
  constructor(db: AngularFirestore) {
    this.items = db.collection('escapingPositions').valueChanges();
  }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts